import React, { useState, useEffect, PropTypes } from "react"
import Autosuggest from 'react-autosuggest';
import _ from "lodash"
import axios from 'axios';
import './assets/styles/_index.scss';
import $ from 'jquery'
import { navigate } from "@reach/router";
import {
  isTablet,
  isIPad13,
  isIOS13,
  isMobile,
  isMobileOnly,
  isDesktop,
} from "react-device-detect";

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => `${suggestion.districtCountyTown} ${(suggestion.location) ? `(${suggestion.location})` : ''}`;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
    {`${suggestion.districtCountyTown} ${(suggestion.location) ? `(${suggestion.location})` : ''}`}
  </div>
);

class SearchResultBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props?.value,
      suggestions: [],
      areas: props?.areaList || [],
      aliasVal: "",
      isChages: false,
      suggestionselected: false
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
      aliasVal: newValue,
      isChages: true
    });
    // if (this?.props?.setValue) {
    //   if (isTablet || isMobile) {
    //     this.props.setValue(newValue, false)
    //   }
    // }
  };
  onKeyDown = (event) => {
    if (event.key == "Enter") {
      if (!this.state.suggestionselected) {
        this.setState({
          value: ''
        });
        if ($("#resultssearch").val() == "") {
          localStorage.setItem('searchValue', '');
          localStorage.setItem('searchValueFull', '');
          localStorage.setItem('searchValueFullName', '');
          // if (localStorage.getItem('pagesearchType') == 'lettings') {
          //   if (typeof window !== 'undefined')
          //     window.location.replace(process.env.GATSBY_SITE_URL + '/property/to-rent/in--blackwater-newport-isle-of-wight/');
          // } else if (localStorage.getItem('pagesearchType') == 'sales') {
          //   if (typeof window !== 'undefined')
          //     window.location.replace(process.env.GATSBY_SITE_URL + '/property/for-sale/in-blackwater-newport-isle-of-wight/');
          // } else if (localStorage.getItem('pagesearchType') == 'newhome') {
          //   if (typeof window !== 'undefined')
          //     window.location.replace(process.env.GATSBY_SITE_URL + '/property/new-homes/for-sale/in-blackwater-newport-isle-of-wight/');
          // }
        }
        $("#resultssearch").val("")
      }
      $(".select-area-error").show().delay(4000).fadeOut();
    }
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  suggestionSelected = (e, { suggestion }) => {
    if (suggestion) {
      this.setState({
        value: `${suggestion.districtCountyTown} ${(suggestion.location) ? `(${suggestion.location})` : ''}`,
        aliasVal: suggestion.districtCountyTown,
      });
      if (this?.props?.setValue) {
        this.props.setValue(suggestion.districtCountyTown, true)
      }
      localStorage.setItem("searchCounty", suggestion.county);
      this.setState({
        suggestionselected: true
      });
      var target = $(".search-result-page");
      $('html,body').animate({
        scrollTop: target.offset().top - 250
      }, 100);
    }
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  getitems = async url => {
    try {
      const { data } = await axios.get(url, {})
      // this.setState({ areas: data })
      let dummyData = [
        {
          name: "Terraced",
          location: '',
          latLng: '51.7384, -1.23815'
        },
        {
          name: "terraced house",
          location: '',
          latLng: '51.7384, -1.23815'
        }
      ]
      this.setState({ areas: data })
      if (this?.props?.setList)
        this.props.setList(data)
    } catch (error) {
      console.error(error)
    }
  }

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : this.state.areas.filter(area =>
      area.districtCountyTown.toLowerCase().slice(0, inputLength) === inputValue
    );
  };

  componentDidMount() {
    if (!this.state.areas.length) {
      let url = process.env.GATSBY_STRAPI_FEED_SRC + "/areas?_limit=-1" // process.env.GATSBY_STRAPI_SRC + "/areas"; // TODO: base URL supposed to be from .env
    }

  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  render() {
    const { value, suggestions, isChages, aliasVal } = this.state;

    // Autosuggest will pass through all these props to the input.
    var setVal = value;
    var setAliasVal = aliasVal;
    if (_.isEmpty(setVal) && !isChages && !_.isEmpty(this.props.areaVal)) {
      setVal = this.props.areaVal;
      setAliasVal = this.props.areaVal
    }

    const inputProps = {
      placeholder: this.props.placeHolder,
      value: setVal,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      className: 'form-control',
      name: "resultssearch",
      id: "resultssearch"
    };

    // Finally, render it!
    return (
      <div className="filter-search">
        <div id="select-area-error" className="select-area-error">Please select a town or area from the dropdown.</div>
        <Autosuggest
          id="react-autosuggest-7"
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          onSuggestionSelected={this.suggestionSelected}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
        // alwaysRenderSuggestions={true}
        />
        <a className="search-icon" href="#">
          <i className="icon-pin"></i>
        </a>
        <input type="hidden" className="searchVal" name="head-search-address-val" id="search-address-filter" value={value || aliasVal} />
      </div>
    );
  }
}

export default SearchResultBox;
